/* eslint-disable no-console */
import {unregister} from 'register-service-worker'

try {
    unregister();
} catch (e) {
    console.log('unregister-1:', e)
}

try {
    workbox.precaching.cleanupOutdatedCaches()
} catch (e) {
    console.log('unregister-2:', e)
}

try {
    navigator.serviceWorker.getRegistrations().then(
        function (registrations) {
            for (let registration of registrations) {
                registration.unregister()
                    .then(function () {
                        return self.clients.matchAll();
                    })
                    .then(function (clients) {
                        clients.forEach(client => {
                            if (client.url && "navigate" in client) {
                                client.navigate(client.url);
                            }
                        });
                    });
            }
        });
} catch (e) {
    console.log('unregister-3:', e)
}
